import { Create, StoresRecord, Update } from "@/pocketbase-types"
import { sortBy } from "@/utils"
import { defineStore, acceptHMRUpdate } from "pinia"

export const useStoreStore = defineStore("store", {
  state: () => ({
    stores: [] as StoresRecord[]
  }),
  getters: {},
  actions: {
    async refresh() {
      this.stores = await this.pb.collection("stores").getFullList({ sort: "+name" })
    },
    async create(props: Omit<Create<"stores">, "household">) {
      const store = await this.pb
        .collection("stores")
        .create({ ...props, household: this.pb.authStore.record?.household })
      this.stores.push(store)
      this.stores.sort(sortBy(s => s.name))
    },
    async update(store: StoresRecord, props: Update<"stores">) {
      const updated = await this.pb.collection("stores").update(store.id, props)
      const idx = this.stores.findIndex(s => s.id == store.id)

      if (idx > -1) {
        this.stores.splice(idx, 1, updated)
        this.stores.sort(sortBy(s => s.name))
      } else {
        await this.refresh()
      }
    },
    async delete(store: StoresRecord) {
      await this.pb.collection("stores").delete(store.id)
      const idx = this.stores.findIndex(s => s.id == store.id)
      if (idx > -1) {
        this.stores.splice(idx, 1)
      }
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useStoreStore, import.meta.hot))
}
